// extracted by mini-css-extract-plugin
module.exports = {"left":"FoodModalRightSide_left__1Qca3"};